export const REFERRAL_DOWNLOAD_URL_STRING = 'https://app.adjust.com/4d2k34v_c2m3moy?deep_link=vividseats%3A%2F%2F'

export const ERROR_MESSAGE = 'Please enter a valid phone number'

export const BUTTON_LABELS = {
    sendLink: 'Send Download Link',
    linkSent: 'Download Link Sent',
}

export const API_SUCCESS_RESPONSE = 'Send successful!'
